import { api } from "../../lib/konnective-api-client";
import { Order, Click } from "../../types/api";

export const postOrder = async (order: Order) => {
  try {
    const { data } = await api.post('/order_v1', {...order,});
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const getProduct = async (productId: string) => {
  const { data } = await api.get(`/product/${productId}`);
  return data;
}

export const postClick = async (click: Click) => {
  try {
    const { data } = await api.post('/click', {...click,});
    return data;      
  } catch (e) {
    console.log(e);   
  }
}